import 'slick-carousel/slick/slick'

export default class PostsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-posts-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 5,
                slidesToScroll: 4,
                dots: true,
                appendDots: $('.js-posts-slider-dots'), // Append the dots to the element with the .js-posts-slider-dots class
                prevArrow: $('.js-posts-slider-previous'), // Use the element with the .js-posts-slider-previous class as the previous arrow
                nextArrow: $('.js-posts-slider-next'), // Use the element with the .js-posts-slider-next class as the next arrow

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        }

    }

};

new PostsSlider();